import * as actions from '../../ActionType/UserActionType';
const initExercise = {
    allDocumentsGroup:[],
    createDocumentsGroup:[],
    deleteDocumentsGroup:[],
    getByIdDocumentGroup:[],
    addDocumentFormGroup:[],
    permissions:[],
    userGroupPermissions:[],
    userPermissions:[],
    updateDocumentGroup:[],
    treeStructureDocument:[],
}
export const DcumentGroupReducer = (state = initExercise, action:any) => {
    switch (action.type) { 
        case actions.CREATE_DOCUMENT_GROUP: 
        return{
            ...state,
            createDocumentsGroup:action.payload
        };
        case actions.ALL_DOCUMENTS_GROUP: 
        return{
            ...state,
            allDocumentsGroup:action.payload
        };
        case actions.DELETE_DOCUMENT_GROUP: 
        return{
            ...state,
            deleteDocumentsGroup:action.payload
        };
        case actions.GET_DOCUMENT_GROUP_BYID:
            return{
                ...state,
                getByIdDocumentGroup:action.payload
        };
        case actions.ADD_DOCUMENT_FORM_GROUP: 
            return{
                ...state,
                addDocumentFormGroup:action.payload
        };
        case actions.ADD_PERMISSION: 
            return{
                ...state,
                permissions:action.payload
        };
        case actions.USER_DELETE_PERMISSION: 
            return{
                ...state,
                userPermissions:action.payload
        };
        case actions.USER_GROUP_DELETE_PERMISSION: 
            return{
                ...state,
                userGroupPermissions:action.payload
        };
        case actions.UPDATE_DOCUMENT_GROUP: 
        return{
            ...state,
            updateDocumentGroup:action.payload
        };
        case actions.TREE_STRUCTURE_LIST_DOCUMENT_GROUP: 
        return{
            ...state,
            treeStructureDocument:action.payload
        };
        default:
         return state;
    }
}